import aggregateClasses from './aggregate-classes';
export default aggregateClasses;
